import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';

function Tab1({ fulldata, order_id, activityboll, pickListId }) {
    const [showActivity, setShowActivity] = useState(true);

    return (
             <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "74vh",
           minHeight: "74vh",
        overflowY: "scroll",
   
      }}
    >
        <div style={{     maxHeight: "74vh",}}>

            {/* Top Section */}
            {/* <div style={{ height: '28vh' }}> */}
                <div className="d-flex gap-3" style={{ marginBottom: '6px' }}>
                    <div className="" style={{ width: '50%' }}>
                        <Input
                            id="No"
                            label="No."
                            value={pickListId}
                            readOnly
                            style={{ height: '30px' }}
                        />
                    </div>

                    <div className="" style={{ width: '50%' }}>
                        <Input
                            id="orderdatepo"
                            label="Order Date"
                            value={fulldata?.date}
                            readOnly={true}
                            style={{ height: '30px' }}
                        />
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '10px' }}>
                    <Input
                        id="purpose"
                        label="Purpose"
                        value={fulldata?.purpose}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <Input
                        id="workOrder"
                        label="Work Order"
                        value={fulldata?.work_order || ''}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

                <div className="col-12" style={{ marginBottom: '10px' }}>
                    <Input
                        id="deliveryDate"
                        label="Delivery Date"
                        value={fulldata?.date}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>
                        <div className="col-12" style={{ marginBottom: '10px' }}>
                    <Input
                        id="assigned to"
                        label="Assigned To"
                        value={fulldata?.assigned_to}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>
            {/* </div> */}

            {/* Middle Section */}
            {/* <div style={{ paddingLeft : '9px' , fontSize: '12px'}}>
                <Checkbox
                    id="considerRejectedWarehouses"
                    label="Consider Rejected Warehouses"
                    checked={fulldata?.message?.consider_rejected_warehouses === 1}
                    description="Items under this warehouse will be suggested"
                    style={{ marginBottom: '4px', fontSize: '13px' }}
                    readOnly={true}
                />
                <p style={{ color: '#a6a8ab', paddingLeft: '13px' }}>Items under this warehouse will be suggested</p>



                <div className="col-12" style={{ marginBottom: '11px' }}>
                    <Input
                        id="Remarks"
                        label="Remarks"
                        value={fulldata?.message?.remarks || ''}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

                <Checkbox
                    id="pickManually"
                    label="Pick Manually"
                    checked={fulldata?.message?.pick_manually === 1}
                    description="If enabled then system won't override the picked qty / batches / serial numbers."
                    style={{ marginBottom: '10px' }}
                    readOnly
                />
                <p style={{ color: '#a6a8ab', paddingLeft: '13px' }}>If enabled then system won't override the picked qty / batches / serial numbers.
                </p>


                <Checkbox
                    id="ignorePricingRule"
                    label="Ignore Pricing Rule"
                    checked={fulldata?.message?.ignore_pricing_rule === 1}
                    description="If enabled then system won't apply the pricing rule on the delivery note which will be created from the pick list"
                    readOnly
                />
                    <p style={{ color: '#a6a8ab', paddingLeft: '13px' }}>If enabled then system won't apply the pricing rule on the delivery note which will be create from the pick list
                </p>
            </div> */}

            {/* Activity Section */}
            {/* <div style={{ height: '14vh' }}> */}
                <div className="col-12">
                    <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                        <p className="firstcolor m-0">
                            Activity
                        </p>
                        <GetIcon
                            iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                            size={22}
                        />
                    </div>
                    {showActivity && (
                        <VersionHistory
                            doctype="Pick List"
                            docname={pickListId}
                            activityboll={activityboll}
                        />
                    )}
                </div>
            {/* </div> */}
        </div>
                </div>

    );
}

export default Tab1;